/** A horizontal Flexbox */

import classNames from 'classnames'
import type { HTMLAttributes, Ref } from 'react'
import styles from './horizontal-box.module.css'

export const HBox = ({ className, ref, ...props }: HTMLAttributes<HTMLDivElement> & { ref?: Ref<HTMLDivElement> }) => (
  <div ref={ref} className={classNames(styles.root, className)} {...props} />
)
